import React from "react";
import ReactDOM from "react-dom";
import Home from "./App";
import "./styles/index.scss";

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById("root")
);
